(() => {
  if (window.__homaPicTuneIntroInit) return;
  window.__homaPicTuneIntroInit = true;

  const root = document.querySelector('[data-homa-pictune-intro]');
  if (!root) return;

  const assetEl = document.getElementById('homa-pictune-assets');
  let assets = {};
  try {
    assets = JSON.parse(assetEl?.textContent || '{}');
  } catch {
    assets = {};
  }
  const A = (key) => assets[key] || '';

  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));

  const scroller = document.querySelector('.page-wrapper');
  const innerScrollMq = window.matchMedia('(min-width: 990px)');
  const usesInnerScroll = () => Boolean(scroller) && innerScrollMq.matches;
  const bindScroll = (fn) => {
    window.addEventListener('scroll', fn, { passive: true });
    scroller?.addEventListener('scroll', fn, { passive: true });
  };

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const band = (p, start, end) => {
    if (end === start) return p >= end ? 1 : 0;
    return clamp((p - start) / (end - start), 0, 1);
  };

  /* ---------- asset tags ---------- */
  $$('[data-pt-asset]').forEach((img) => {
    const key = img.getAttribute('data-pt-asset');
    const url = A(key);
    if (url) img.src = url;
  });

  /* ---------- shop swatches ---------- */
  const colorName = $('[data-pt-color-name]');
  const colorPreview = $('[data-pt-color-preview]');
  $$('[data-pt-swatch]').forEach((btn) => {
    btn.addEventListener('click', () => {
      $$('[data-pt-swatch]').forEach((b) => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      if (colorName) colorName.textContent = btn.dataset.name || '';
      if (colorPreview) {
        colorPreview.style.background = btn.dataset.swatch || '';
      }
    });
  });
  if (colorPreview) colorPreview.style.background = '#e6dfd4';

  /* ---------- distance card screen fade ---------- */
  const distanceSlides = $$('.pt-distance-card__slide');
  if (distanceSlides.length > 1) {
    let tick = 0;
    setInterval(() => {
      tick += 1;
      distanceSlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === tick % distanceSlides.length);
      });
    }, 2600);
  }

  /* ---------- agent card ---------- */
  const FLOATS = [
    { key: 'pictune/v4/card2/float-george.png', left: '1%', top: '22%', w: '19%', r: -8 },
    { key: 'pictune/v4/card2/float-audio.png', left: '16%', top: 'calc(46% - 14px)', w: '16%', r: -3, z: 2 },
    { key: 'pictune/v4/card2/float-cctv.png', left: '31%', top: '8%', w: '20%', r: 5 },
    { key: 'pictune/v4/card2/float-visitor.png', left: '50%', top: '34%', w: '18%', r: -2 },
    { key: 'pictune/v4/card2/float-stranger.png', left: '66%', top: '6%', w: '18%', r: 8 },
    { key: 'pictune/v4/card2/float-family.png', left: '81%', top: '30%', w: '17%', r: 3 },
  ];
  const agentStage = $('[data-pt-agent-card]');
  if (agentStage) {
    let hot = -1;
    FLOATS.forEach((card, index) => {
      const img = document.createElement('img');
      img.src = A(card.key);
      img.alt = '';
      img.className = 'pt-agent-float';
      img.style.left = card.left;
      img.style.top = card.top;
      img.style.width = `calc(${card.w} - 10px)`;
      img.style.transform = `rotate(${card.r}deg)`;
      img.style.zIndex = String(card.z || 1);
      img.addEventListener('mouseenter', () => {
        hot = index;
        $$('.pt-agent-float', agentStage).forEach((el, i) => {
          el.classList.toggle('is-hot', i === hot);
          if (i !== hot) el.style.zIndex = String(FLOATS[i].z || 1);
        });
      });
      img.addEventListener('mouseleave', () => {
        hot = -1;
        $$('.pt-agent-float', agentStage).forEach((el, i) => {
          el.classList.remove('is-hot');
          el.style.zIndex = String(FLOATS[i].z || 1);
        });
      });
      agentStage.appendChild(img);
    });
  }

  /* ---------- tailored card ---------- */
  const AVATARS = [
    { key: 'pictune/v4/avatar-b.jpg', label: 'Child', left: 'calc(81.15% - 21px)', top: '35px', scale: 253, x: '-72.4%', y: '-35.8%' },
    { key: 'pictune/v4/avatar-c.png', label: 'Grandparent', left: 'calc(83.2% - 21px)', top: '141px', scale: 256, x: '-70%', y: '-36%' },
    { key: 'pictune/v4/avatar-a.jpg', label: 'Mike', left: 'calc(85.25% - 21px)', top: '247px', scale: 277, x: '-81.4%', y: '-37.9%' },
  ];
  const tailoredStage = $('[data-pt-tailored-card]');
  if (tailoredStage) {
    AVATARS.forEach((avatar) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pt-tailored-avatar';
      btn.setAttribute('aria-label', avatar.label);
      btn.style.left = avatar.left;
      btn.style.top = avatar.top;
      const img = document.createElement('img');
      img.src = A(avatar.key);
      img.alt = '';
      img.style.width = `${avatar.scale}%`;
      img.style.height = `${avatar.scale}%`;
      img.style.left = avatar.x;
      img.style.top = avatar.y;
      btn.appendChild(img);
      btn.addEventListener('click', () => {
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
      });
      btn.addEventListener('animationend', () => btn.classList.remove('is-pop'));
      tailoredStage.appendChild(btn);
    });
  }

  /* ---------- hub card ---------- */
  const hubStage = $('[data-pt-hub-card]');
  if (hubStage) {
    const layer = document.createElement('div');
    layer.className = 'pt-hub-layer';
    const screen = document.createElement('img');
    screen.className = 'pt-hub-screen';
    screen.src = A('pictune/v4/card4/screen.png');
    screen.alt = '';
    const visitor = document.createElement('img');
    visitor.className = 'pt-hub-visitor';
    visitor.src = A('pictune/v4/card4/visitor.png');
    visitor.alt = '';
    layer.append(screen, visitor);
    layer.addEventListener('mouseenter', () => layer.classList.add('is-hot'));
    layer.addEventListener('mouseleave', () => layer.classList.remove('is-hot'));
    hubStage.appendChild(layer);
  }

  /* ---------- feature carousel ---------- */
  const CARD_COUNT = 4;
  const CARD_GAP = 12;
  const carouselScroller = $('[data-pt-carousel-scroller]');
  const indicatorVisual = $('.pt-carousel__indicator-visual');
  const indicatorBtns = $$('.pt-carousel__indicator-hit button');
  const playBtn = $('[data-pt-carousel-play]');
  let carouselIndex = 0;
  let carouselPlaying = false;
  let carouselTimer = 0;

  const carouselStride = () => {
    const card = carouselScroller?.querySelector('article');
    return (card ? card.offsetWidth : 700) + CARD_GAP;
  };

  const scrollToCarouselCard = (next) => {
    const el = carouselScroller;
    if (!el) return;
    const wrapped = (next + CARD_COUNT) % CARD_COUNT;
    const card = el.querySelectorAll('article')[wrapped];
    const pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
    const left = card ? Math.max(0, card.offsetLeft - pad) : wrapped * carouselStride();
    el.scrollTo({ left, behavior: 'smooth' });
    carouselIndex = wrapped;
    paintCarouselIndicator();
  };

  const paintCarouselIndicator = () => {
    if (!indicatorVisual) return;
    indicatorVisual.querySelectorAll('span').forEach((span, i) => {
      span.classList.toggle('is-active', i === carouselIndex);
    });
  };

  const syncCarouselIndexFromScroll = () => {
    const el = carouselScroller;
    if (!el) return;
    const pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
    const cards = [...el.querySelectorAll('article')];
    let best = 0;
    let bestDist = Infinity;
    cards.forEach((card, i) => {
      const dist = Math.abs(el.scrollLeft - Math.max(0, card.offsetLeft - pad));
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    carouselIndex = best;
    paintCarouselIndicator();
  };

  if (carouselScroller) {
    carouselScroller.addEventListener('scroll', syncCarouselIndexFromScroll, { passive: true });
  }
  indicatorBtns.forEach((btn, i) => {
    btn.addEventListener('click', () => scrollToCarouselCard(i));
  });

  const setCarouselPlaying = (on) => {
    carouselPlaying = on;
    playBtn?.classList.toggle('is-playing', on);
    playBtn?.setAttribute('aria-label', on ? 'Pause' : 'Play');
    clearInterval(carouselTimer);
    if (!on) return;
    carouselTimer = setInterval(() => {
      syncCarouselIndexFromScroll();
      scrollToCarouselCard(carouselIndex + 1);
    }, 5200);
  };

  playBtn?.addEventListener('click', () => setCarouselPlaying(!carouselPlaying));

  /* ---------- distance story tiles ---------- */
  const TILES = [
    { src: 'tile-1.png', x: 17.05, y: 10.02 },
    { src: 'tile-2.png', x: 32.71, y: 10.02 },
    { src: 'tile-3.png', x: 48.38, y: 10.02 },
    { src: 'tile-4.png', x: 64.04, y: 10.02 },
    { src: 'tile-5.png', x: 8.79, y: 33.79 },
    { src: 'tile-6.png', x: 24.45, y: 33.79 },
    { src: 'tile-7.png', x: 40.09, y: 33.79 },
    { src: 'tile-8.png', x: 55.78, y: 33.79 },
    { src: 'tile-9.png', x: 71.44, y: 33.79 },
    { src: 'tile-10.png', x: 64.04, y: 57.49 },
    { src: 'tile-11.png', x: 48.38, y: 57.49 },
    { src: 'tile-12.png', x: 32.71, y: 57.49 },
    { src: 'tile-13.png', x: 17.05, y: 57.49 },
  ];
  const TILE_GROW = 100;
  const TILE_IMG_W0 = 242;
  const TILE_IMG_H0 = 271;
  const TILE_OPAQUE_W0 = 153;
  const TILE_OPAQUE_H0 = 194;
  const TILE_GAP_X = 32;
  const TILE_GAP_Y = 45;
  const tileScale = (TILE_OPAQUE_W0 + TILE_GROW) / TILE_OPAQUE_W0;
  const tileImgW = TILE_IMG_W0 * tileScale;
  const tileImgH = TILE_IMG_H0 * tileScale;
  const tileOpaqueW = TILE_OPAQUE_W0 * tileScale;
  const tileOpaqueH = TILE_OPAQUE_H0 * tileScale;
  const tilePadL = (76 / 395) * tileImgW;
  const tilePadT = (64 / 441) * tileImgH;

  const layoutTiles = () => {
    const rowKeys = [...new Set(TILES.map((t) => t.y))];
    const rows = rowKeys.map((y) => TILES.filter((t) => t.y === y).sort((a, b) => a.x - b.x));
    const rowWidths = rows.map((row) => row.length * tileOpaqueW + (row.length - 1) * TILE_GAP_X);
    const gridW = Math.max(...rowWidths);
    const gridH = rows.length * tileOpaqueH + (rows.length - 1) * TILE_GAP_Y;
    const placed = [];
    rows.forEach((row, rowIndex) => {
      const originX = (gridW - rowWidths[rowIndex]) / 2;
      const opaqueTop = rowIndex * (tileOpaqueH + TILE_GAP_Y);
      row.forEach((tile, column) => {
        const opaqueLeft = originX + column * (tileOpaqueW + TILE_GAP_X);
        placed.push({
          ...tile,
          left: opaqueLeft - tilePadL,
          top: opaqueTop - tilePadT,
          cx: opaqueLeft + tileOpaqueW / 2,
          cy: opaqueTop + tileOpaqueH / 2,
        });
      });
    });
    return { placed, gridW, gridH };
  };

  const tileLayout = layoutTiles();
  /* Design-team motion: peripheral tiles absorb into the three core cards,
     then cores collapse into the device. Matches PicTuneIntro on showcase. */
  const CORE_TILES = new Set(['tile-6.png', 'tile-7.png', 'tile-8.png']);
  const coreTiles = tileLayout.placed.filter((tile) => CORE_TILES.has(tile.src));
  const tileMotion = tileLayout.placed.map((tile) => {
    const center = { x: tile.cx, y: tile.cy };
    if (CORE_TILES.has(tile.src)) return { ...tile, core: true, center };
    let target = coreTiles[0];
    let best = Infinity;
    coreTiles.forEach((core) => {
      const distance = (core.cx - center.x) ** 2 + (core.cy - center.y) ** 2;
      if (distance < best) {
        best = distance;
        target = core;
      }
    });
    return { ...tile, core: false, center, target };
  });

  const tilesRoot = $('[data-pt-distance-tiles]');
  const tileEls = [];
  const syncTileScale = () => {
    if (!tilesRoot) return;
    const viewport = Math.min(window.innerWidth, document.documentElement.clientWidth || window.innerWidth);
    let scale = 1;
    if (viewport < 750) scale = Math.min(1, (viewport * 0.92) / tileLayout.gridW);
    else if (viewport < 990) scale = Math.min(1, (viewport * 0.88) / tileLayout.gridW);
    tilesRoot.style.setProperty('--pt-tile-scale', String(scale));
  };
  if (tilesRoot) {
    tilesRoot.style.width = `${tileLayout.gridW}px`;
    tilesRoot.style.height = `${tileLayout.gridH}px`;
    tileMotion.forEach((tile) => {
      const img = document.createElement('img');
      img.className = 'pt-story__tile';
      if (tile.core) img.classList.add('is-core');
      img.src = A(`pictune/v4/cut/${tile.src}`);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.style.left = `${tile.left}px`;
      img.style.top = `${tile.top}px`;
      img.style.width = `${tileImgW}px`;
      img.style.zIndex = tile.core ? '3' : '1';
      img.style.transform = 'translate3d(0,0,0) scale(1)';
      tilesRoot.appendChild(img);
      tileEls.push({ img, tile });
    });
    syncTileScale();
    window.addEventListener('resize', syncTileScale, { passive: true });
  }

  /* ---------- distance frame (5m→3m→1m) ---------- */
  const FRAME_W = 768;
  const FRAME_H = 1024;
  const xp = (n) => `${(n / FRAME_W) * 100}%`;
  const yp = (n) => `${(n / FRAME_H) * 100}%`;
  const fs = (n) => `${(n / FRAME_H) * 100}cqh`;
  const rad = (n) => `${(n / FRAME_W) * 100}cqw`;

  const frameSrc = (rel) => {
    if (rel.startsWith('pictune/')) return A(rel);
    return A(`pictune/frame/${rel}`);
  };

  const METER_CARDS = [
    { key: 'george', kind: 'photo', src: '3m/george.png', x: 32, y: 291.6, w: 230, h: 305, rot: -3.15, label: 'George shared a\nmoment with you!' },
    { key: 'video', kind: 'photo', src: '3m/stranger.jpg', x: 270, y: 282, w: 240, h: 313, rot: 1.96, label: 'Stranger\nThings 4', logo: '3m/netflix-n.png' },
    { key: 'family', kind: 'photo', src: '3m/family.jpg', x: 503, y: 286.4, w: 240, h: 312, rot: -1.84, label: 'Family · 1\nplan left' },
    { key: 'audio', kind: 'audio', x: 31.2, y: 639.2, w: 237.4, h: 310.6, rot: -5.37, z: 2 },
    { key: 'epg', kind: 'epg', x: 248.7, y: 624.9, w: 257.6, h: 325.2, rot: 1.41 },
    { key: 'visitor', kind: 'photo', src: '3m/homa-doorbell-visitor.png', x: 506.74, y: 631, w: 230, h: 312, rot: -1.8, label: 'Visitor' },
  ];

  const DOCK_ICONS = [
    'app-tiktok.png',
    'app-qqmusic.png',
    'app-spotify.png',
    'app-netflix.png',
    'app-youtube.png',
    'app-instagram.png',
  ];

  const frameWrap = $('[data-pt-distance-frame]');
  let frameRoot = null;
  let outdoorEl = null;
  let emotionTimeEl = null;
  let periodEl = null;
  let dayEl = null;
  let clockBarEl = null;
  let eventClockEl = null;
  let sunnyNightIcon = null;

  const boxStyle = (x, y, w, h, extra = '') =>
    `position:absolute;left:${xp(x)};top:${yp(y)};width:${xp(w)};height:${yp(h)};${extra}`;

  const buildDistanceFrame = () => {
    if (!frameWrap) return;
    frameRoot = document.createElement('div');
    frameRoot.className = 'pt-distance-frame';

    const bezel = document.createElement('img');
    bezel.className = 'pt-distance-frame__bezel';
    bezel.src = A('pictune/v4/cut/screen-3m.png');
    bezel.alt = '';
    frameRoot.appendChild(bezel);

    const screen = document.createElement('div');
    screen.className = 'pt-distance-frame__screen';

    const blur = document.createElement('img');
    blur.src = frameSrc('1m/mom.jpg');
    blur.alt = '';
    blur.style.cssText = 'position:absolute;left:-12%;top:-8%;width:124%;height:116%;object-fit:cover;filter:blur(18px) saturate(0.8);opacity:0.7';
    screen.appendChild(blur);

    const layer3 = document.createElement('div');
    layer3.className = 'pt-distance-frame__layer pt-distance-frame__layer--3m';
    layer3.innerHTML = `
      <div style="position:absolute;inset:0;background:linear-gradient(180deg,rgba(255,255,255,0.78),rgba(255,255,255,0.42) 24%,rgba(255,255,255,0.16))"></div>
      <div style="${boxStyle(40, 36, 688, 210)}display:flex;justify-content:space-between;align-items:flex-start;color:#6a635c">
        <div style="font-size:${fs(18)};line-height:1.15"><div>Indoor</div>
          <div style="display:flex;align-items:center;gap:${rad(6)};margin-top:${fs(2)};color:#4c4742;font-size:${fs(36)};font-weight:450">22° 45%
            <img src="${frameSrc('3m/drop.png')}" alt="" style="width:${rad(26)};height:${rad(26)}">
          </div>
        </div>
        <div style="text-align:center;color:#5c564f">
          <div style="display:flex;align-items:flex-end;justify-content:center">
            <span data-pt-emotion-time style="font-size:${fs(72)};font-weight:400;letter-spacing:-0.04em;line-height:0.9"></span>
            <span data-pt-period style="margin:0 0 ${fs(8)} ${rad(6)};font-size:${fs(26)};line-height:1"></span>
          </div>
          <div data-pt-day style="margin-top:${fs(4)};font-size:${fs(24)}"></div>
        </div>
        <div style="text-align:right;font-size:${fs(22)};line-height:1.15">
          <div>Shenzhen</div>
          <div style="display:flex;align-items:center;justify-content:flex-end;gap:${rad(6)};margin-top:${fs(2)};color:#4c4742;font-size:${fs(36)};font-weight:450">
            <span data-pt-outdoor>30</span>°
            <img data-pt-weather-icon src="${frameSrc('1m/sunny.svg')}" alt="" style="width:${rad(40)};height:${rad(40)}">
          </div>
        </div>
      </div>`;

    METER_CARDS.forEach((card) => {
      const cardEl = document.createElement('div');
      cardEl.style.cssText = boxStyle(
        card.x,
        card.y,
        card.w,
        card.h,
        `transform:rotate(${card.rot}deg);border-radius:${rad(26)};overflow:hidden;z-index:${card.z || 1};box-shadow:0 12px 22px rgba(70,48,28,0.18)`
      );
      if (card.kind === 'photo') {
        cardEl.innerHTML = `
          <img src="${frameSrc(card.src)}" alt="" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover">
          <div style="position:absolute;inset:0;background:linear-gradient(180deg,transparent 46%,rgba(0,0,0,0.58) 100%)"></div>
          ${card.logo ? `<img src="${frameSrc(card.logo)}" alt="" style="position:absolute;left:8%;top:28%;width:28%;height:22%;object-fit:contain">` : ''}
          <div style="position:absolute;left:8%;right:8%;bottom:7%;color:#fff;font-weight:560;font-size:${fs(26)};line-height:1.05;white-space:pre-line;text-shadow:0 1px 6px rgba(0,0,0,0.35)">${card.label}</div>`;
      } else if (card.kind === 'audio') {
        cardEl.innerHTML = `
          <div style="position:absolute;inset:0;background:linear-gradient(180deg,rgba(255,255,255,0.34),rgba(90,90,90,0.28))"></div>
          <img src="${frameSrc('3m/homa-audio-back.png')}" alt="" style="position:absolute;left:25%;top:18%;width:67%;aspect-ratio:1;object-fit:cover;border-radius:${rad(10)}">
          <img src="${frameSrc('3m/homa-audio-front.png')}" alt="" style="position:absolute;left:-6%;top:10%;width:78%;aspect-ratio:1;object-fit:cover;border-radius:${rad(10)};box-shadow:0 8px 16px rgba(0,0,0,0.18)">
          <div style="position:absolute;left:8%;bottom:7%;color:#fff;font-size:${fs(28)};font-weight:500;line-height:1.05">HOMA<br>Audio</div>`;
      } else if (card.kind === 'epg') {
        cardEl.innerHTML = `
          <img src="${frameSrc('3m/epg-card-scene.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover">
          <div style="position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,0.05),rgba(0,0,0,0.45))"></div>
          <img src="${frameSrc('3m/epg-card-logo.png')}" alt="" style="position:absolute;left:6%;bottom:16%;width:28%;height:14%;object-fit:contain">
          <div style="position:absolute;left:38%;right:6%;bottom:8%;color:#fff;font-size:${fs(22)};font-weight:560;line-height:1.05">0196<br>CCTV finance</div>`;
      }
      layer3.appendChild(cardEl);
    });

    const layer1 = document.createElement('div');
    layer1.className = 'pt-distance-frame__layer pt-distance-frame__layer--1m';
    layer1.innerHTML = `
      <div style="position:absolute;inset:0;background:linear-gradient(180deg,rgba(40,36,32,0.18),rgba(40,36,32,0.05) 30%,rgba(40,36,32,0.12))"></div>
      <span data-pt-clock-bar style="${boxStyle(20, 18, 140, 28)}font-size:${fs(20)};line-height:${fs(24)}"></span>
      <span style="${boxStyle(318, 16, 132, 32)}display:flex;align-items:center;justify-content:center;gap:${rad(6)};border-radius:${rad(20)};background:rgba(0,0,0,0.28);font-size:${fs(18)}">
        <i style="width:${rad(8)};height:${rad(8)};border-radius:50%;background:#67EE43"></i> Armed
      </span>
      <span style="${boxStyle(520, 18, 228, 28)}display:flex;align-items:center;justify-content:flex-end;font-size:${fs(18)}">
        25°<span style="margin-left:${rad(8)}">65%</span>
        <img src="${frameSrc('1m/humidity.svg')}" alt="" style="width:${rad(22)};height:${rad(22)};margin-left:${rad(2)}">
        <span style="width:${rad(1)};height:${fs(14)};margin:0 ${rad(8)};background:rgba(255,255,255,0.9)"></span>
        30°<img src="${frameSrc('1m/sunny.svg')}" alt="" style="width:${rad(24)};height:${rad(24)};margin-left:${rad(2)}">
      </span>
      <div style="${boxStyle(32, 62, 210, 46)}font-size:${fs(36)};font-weight:500;letter-spacing:-0.03em;line-height:${fs(43)};white-space:nowrap">Hello Anna</div>
      <img src="${frameSrc('1m/mom.jpg')}" alt="" style="${boxStyle(231, 64, 43, 43)}border-radius:50%;object-fit:cover;object-position:center 20%">
      <div style="${boxStyle(33, 112, 320, 52)}font-size:${fs(20)};font-weight:300;line-height:${fs(25)}">Family dinner is the next fixed plan.</div>
      <div style="${boxStyle(382, 64, 220, 26)}font-size:${fs(20)}">Thu May 14, Sat.</div>
      <span style="${boxStyle(668, 66, 72, 24)}border-radius:${rad(12)};background:rgba(80,80,80,0.38);border:1px solid rgba(255,255,255,0.35);font-size:${fs(12)};display:flex;align-items:center;justify-content:center">View all</span>
      <div style="${boxStyle(382, 97, 354, 74)}border-radius:${rad(20)};overflow:hidden;background:linear-gradient(90deg,rgba(79,160,137,0.55),rgba(96,96,96,0.5));border:1px solid rgba(255,255,255,0.35);display:flex;align-items:center;gap:${rad(14)};padding-left:${rad(18)}">
        <img src="${frameSrc('1m/agenda-marker-primary.svg')}" alt="" style="width:${rad(10)};height:${fs(36)};flex:none">
        <span style="font-size:${fs(18)};line-height:1.2"><b style="font-weight:600" data-pt-event-clock></b><br>Family dinner</span>
      </div>
      <div style="${boxStyle(382, 179, 354, 74)}border-radius:${rad(20)};overflow:hidden;background:linear-gradient(90deg,rgba(79,160,137,0.55),rgba(96,96,96,0.5));border:1px solid rgba(255,255,255,0.35);display:flex;align-items:center;gap:${rad(14)};padding-left:${rad(18)}">
        <img src="${frameSrc('1m/agenda-marker-primary.svg')}" alt="" style="width:${rad(10)};height:${fs(36)};flex:none">
        <span style="font-size:${fs(18)};line-height:1.2"><b style="font-weight:600" data-pt-event-clock-2></b><br>Sheet-pan salmon</span>
      </div>
      <div style="${boxStyle(39, 302, 222, 222)}border-radius:${rad(16)};overflow:hidden">
        <img src="${frameSrc('1m/share-photo.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:130%;object-fit:cover;object-position:center 30%">
        <div style="position:absolute;inset:0;background:linear-gradient(180deg,transparent 42%,rgba(0,0,0,0.5))"></div>
        <div style="position:absolute;left:6%;right:8%;bottom:32%;color:#fff;font-size:${fs(16)};font-weight:500;line-height:1.15">George shared a moment with you!</div>
        <span style="position:absolute;left:6%;right:6%;bottom:6%;height:22%;border-radius:99px;background:rgba(0,0,0,0.32);display:flex;align-items:center;justify-content:center;gap:${rad(6)};color:#07C160;font-size:${fs(13)};font-weight:560">
          <img src="${frameSrc('1m/call.svg')}" alt="" style="width:${rad(16)};height:${rad(16)}"> Call George
        </span>
      </div>
      <div style="${boxStyle(273, 302, 222, 222)}border-radius:${rad(16)};overflow:hidden">
        <img src="${frameSrc('1m/stranger-things.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:120%;object-fit:cover;object-position:center 20%">
        <img src="${frameSrc('1m/netflix-n.png')}" alt="" style="position:absolute;left:4%;bottom:28%;width:19%;height:19%;object-fit:contain">
        <div style="position:absolute;left:6%;bottom:7%;width:52%;color:#fff;font-size:${fs(16)};font-weight:500;line-height:1.1">Stranger Things</div>
        <img src="${frameSrc('1m/play.svg')}" alt="" style="position:absolute;right:6%;bottom:8%;width:${rad(46)};height:${rad(46)}">
      </div>
      <div style="${boxStyle(507, 302, 222, 106)}border-radius:${rad(16)};overflow:hidden">
        <img src="${frameSrc('1m/family-dinner.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover;object-position:center 38%">
        <div style="position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,0.05),rgba(0,0,0,0.45))"></div>
        <div style="position:absolute;left:6%;right:6%;bottom:10%;color:#fff;font-size:${fs(15)};font-weight:500">Family dinner 7:55 PM</div>
      </div>
      <div style="${boxStyle(39, 536, 222, 222)}border-radius:${rad(16)};overflow:hidden;background:rgba(124,124,124,0.4);box-shadow:inset 0 0 12px 6px rgba(255,255,255,0.35)">
        <img src="${frameSrc('1m/audio-back.png')}" alt="" style="position:absolute;left:43%;top:14%;width:52%;aspect-ratio:1;object-fit:cover;border-radius:${rad(8)}">
        <img src="${frameSrc('1m/audio-front.png')}" alt="" style="position:absolute;left:5%;top:5%;width:69%;aspect-ratio:1;object-fit:cover;border-radius:${rad(8)}">
        <div style="position:absolute;left:6%;bottom:6%;color:#fff;font-size:${fs(16)};font-weight:500">HOMA Audio</div>
      </div>
      <div style="${boxStyle(273, 536, 222, 106)}border-radius:${rad(16)};overflow:hidden">
        <img src="${frameSrc('1m/epg-scene.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover">
        <div style="position:absolute;inset:0;background:linear-gradient(90deg,rgba(0,0,0,0.2),rgba(0,0,0,0.45))"></div>
        <img src="${frameSrc('1m/epg-logo.png')}" alt="" style="position:absolute;left:5%;top:32%;width:28%;height:30%;object-fit:contain">
        <div style="position:absolute;left:36%;top:28%;color:#fff;font-size:${fs(16)};line-height:1.15;font-weight:500">0196<br>CCTV finance</div>
      </div>
      <div style="${boxStyle(273, 652, 106, 106)}border-radius:${rad(16)};overflow:hidden">
        <img src="${frameSrc('1m/youtube-card.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover">
        <img src="${frameSrc('1m/youtube-logo.svg')}" alt="" style="position:absolute;left:10%;top:36%;width:78%;height:18%;object-fit:contain">
      </div>
      <div style="${boxStyle(389, 652, 106, 106)}border-radius:${rad(16)};overflow:hidden">
        <img src="${frameSrc('1m/disney-card.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover;object-position:center top">
        <img src="${frameSrc('1m/disney-logo.svg')}" alt="" style="position:absolute;left:10%;top:12%;width:78%;height:40%;object-fit:contain">
      </div>
      <div style="${boxStyle(507, 418, 222, 224)}border-radius:${rad(16)};overflow:hidden">
        <img src="${frameSrc('1m/visitor.png')}" alt="" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover;object-position:center 18%">
        <div style="position:absolute;top:4%;right:4%;width:29%;border-radius:${rad(12)};background:rgba(0,0,0,0.32);display:flex;flex-direction:column;align-items:center;padding:${fs(6)} 0 ${fs(4)}">
          <img src="${frameSrc('1m/chime.svg')}" alt="" style="width:46%;height:${rad(22)};object-fit:contain">
          <span style="color:#fff;font-size:${fs(12)};font-weight:500">Visitor</span>
        </div>
      </div>
      <span style="${boxStyle(515, 678, 99, 40)}border-radius:${rad(20)};background:rgba(255,255,255,0.82);color:#222;font-size:${fs(15)};font-weight:560;display:flex;align-items:center;justify-content:center;gap:${rad(6)}">
        <img src="${frameSrc('1m/film.svg')}" alt="" style="width:${rad(18)};height:${rad(18)}"> Film
      </span>
      <span style="${boxStyle(622, 678, 99, 40)}border-radius:${rad(20)};background:rgba(255,255,255,0.82);color:#222;font-size:${fs(15)};font-weight:560;display:flex;align-items:center;justify-content:center;gap:${rad(6)}">
        <img src="${frameSrc('1m/game.svg')}" alt="" style="width:${rad(18)};height:${rad(18)}"> Game
      </span>
      <div style="${boxStyle(507, 724, 222, 24)}text-align:center;font-size:${fs(16)};font-weight:560;text-shadow:0 1px 4px rgba(0,0,0,0.35)">HOMA Home</div>
      <div style="${boxStyle(344, 812, 80, 16)}display:flex;align-items:center;justify-content:center;gap:${rad(8)}">
        <i style="width:${rad(22)};height:${rad(6)};border-radius:99px;background:rgba(255,255,255,0.92)"></i>
        <i style="width:${rad(6)};height:${rad(6)};border-radius:50%;background:rgba(255,255,255,0.55)"></i>
      </div>
      <div data-pt-dock style="${boxStyle(28, 886, 712, 106)}border-radius:${rad(24)};background:rgba(123,123,123,0.3);border:1px solid rgba(255,255,255,0.22);display:flex;align-items:center;justify-content:space-evenly"></div>`;

    screen.append(layer3, layer1);
    frameRoot.appendChild(screen);
    frameWrap.appendChild(frameRoot);

    outdoorEl = layer3.querySelector('[data-pt-outdoor]');
    emotionTimeEl = layer3.querySelector('[data-pt-emotion-time]');
    periodEl = layer3.querySelector('[data-pt-period]');
    dayEl = layer3.querySelector('[data-pt-day]');
    sunnyNightIcon = layer3.querySelector('[data-pt-weather-icon]');
    clockBarEl = layer1.querySelector('[data-pt-clock-bar]');
    eventClockEl = layer1.querySelector('[data-pt-event-clock]');
    const eventClock2 = layer1.querySelector('[data-pt-event-clock-2]');
    if (eventClock2) eventClock2.textContent = eventClockEl?.textContent || '';

    const dock = layer1.querySelector('[data-pt-dock]');
    if (dock) {
      DOCK_ICONS.forEach((icon) => {
        const img = document.createElement('img');
        img.src = frameSrc(`dock/${icon}`);
        img.alt = '';
        img.style.cssText = `width:${rad(64)};height:${rad(64)};border-radius:${rad(14)};object-fit:cover`;
        dock.appendChild(img);
      });
    }
  };

  buildDistanceFrame();

  let outdoorTemp = 30;
  fetch(
    'https://api.open-meteo.com/v1/forecast?latitude=22.5333&longitude=113.93&current=temperature_2m&timezone=Asia%2FShanghai'
  )
    .then((r) => r.json())
    .then((data) => {
      if (Number.isFinite(data?.current?.temperature_2m)) {
        outdoorTemp = Math.round(data.current.temperature_2m);
        if (outdoorEl) outdoorEl.textContent = String(outdoorTemp);
      }
    })
    .catch(() => {});

  const updateClock = () => {
    const now = Date.now();
    const date = new Date(now);
    const parts = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).formatToParts(date);
    const emotionTime = `${parts.find((p) => p.type === 'hour')?.value ?? ''}:${parts.find((p) => p.type === 'minute')?.value ?? ''}`;
    const period = (parts.find((p) => p.type === 'dayPeriod')?.value ?? '').toUpperCase();
    const day = `${date.toLocaleDateString('en-US', { weekday: 'short' })} ${date.toLocaleDateString('en-US', { month: 'short' })} ${date.getDate()}`;
    const eventClock = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(new Date(now + 30 * 60 * 1000));
    const night = date.getHours() >= 18 || date.getHours() < 6;

    if (emotionTimeEl) emotionTimeEl.textContent = emotionTime;
    if (periodEl) periodEl.textContent = period;
    if (dayEl) dayEl.textContent = day;
    if (clockBarEl) clockBarEl.textContent = `${emotionTime} ${period}`;
    if (eventClockEl) eventClockEl.textContent = eventClock;
    const eventClock2 = root.querySelector('[data-pt-event-clock-2]');
    if (eventClock2) eventClock2.textContent = eventClock;
    if (sunnyNightIcon) {
      sunnyNightIcon.src = night ? frameSrc('3m/drop.png') : frameSrc('1m/sunny.svg');
      sunnyNightIcon.style.filter = night ? 'grayscale(1) brightness(1.6)' : 'none';
    }
  };
  updateClock();
  setInterval(updateClock, 1000);

  /* ---------- scroll story ---------- */
  const story = $('[data-pt-distance-story]');
  const pin = $('[data-pt-distance-pin]');
  const phases = $$('[data-pt-phase]');

  let layer3El = null;
  const paintStory = (progress) => {
    const intoFrames = band(progress, 0.04, 0.28);
    const easeFrames = intoFrames * intoFrames * (3 - 2 * intoFrames);
    const intoDevice = band(progress, 0.38, 0.54);
    const easeDevice = intoDevice * intoDevice * (3 - 2 * intoDevice);
    const presence = band(progress, 0.5, 0.62);
    const depth = 1 + band(progress, 0.68, 0.94);
    const exit = depth <= 1.06 ? 1 : depth >= 1.32 ? 0 : 1 - (depth - 1.06) / 0.26;
    const enter = band(depth, 1, 1.12);
    const settle = band(depth, 1, 2);
    const scale = 0.9 + presence * 0.1 + band(depth, 1, 2) * 0.02;

    if (frameRoot) {
      frameRoot.style.opacity = String(presence);
      frameRoot.style.transform = `translate3d(-50%, -50%, 0) scale(${scale})`;
      frameRoot.style.setProperty('--pt-exit', String(exit));
      frameRoot.style.setProperty('--pt-enter', String(enter));
      if (!layer3El) layer3El = frameRoot.querySelector('.pt-distance-frame__layer--3m');
      if (layer3El) {
        const ty = ((-7.5 * settle) / FRAME_H) * 100;
        layer3El.style.transform = `scale(${1.02 * (1 + settle * 0.01)}) translateY(${ty}cqh)`;
      }
    }

    tileEls.forEach(({ img, tile }) => {
      const absorbed = tile.core ? 0 : easeFrames;
      const collapse = tile.core ? easeDevice : 0;
      const left = tile.core
        ? tile.left + (tileLayout.gridW / 2 - tile.center.x) * collapse
        : tile.left + (tile.target.left - tile.left) * absorbed;
      const top = tile.core
        ? tile.top + (tileLayout.gridH / 2 - tile.center.y) * collapse
        : tile.top + (tile.target.top - tile.top) * absorbed;
      const opacity = tile.core
        ? 1 - band(progress, 0.48, 0.58)
        : 1 - band(easeFrames, 0.42, 1);
      const s = tile.core ? 1 - collapse * 0.72 : 1 - absorbed * 0.62;
      img.style.transform = `translate3d(${left - tile.left}px, ${top - tile.top}px, 0) scale(${s})`;
      img.style.opacity = String(opacity);
      img.style.visibility = opacity < 0.02 ? 'hidden' : 'visible';
    });

    const copyOpacity = [
      1 - band(progress, 0.4, 0.48),
      band(progress, 0.5, 0.6) * (1 - band(progress, 0.68, 0.8)),
      band(progress, 0.8, 0.94),
    ];
    phases.forEach((phase, i) => {
      const on = copyOpacity[i] > 0.35;
      phase.classList.toggle('is-active', on);
      phase.style.opacity = String(copyOpacity[i]);
    });
  };

  let storyRaf = 0;
  let lastProgress = -1;
  const onStoryScroll = () => {
    if (!story || storyRaf) return;
    storyRaf = requestAnimationFrame(() => {
      storyRaf = 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) {
        if (lastProgress !== 0.66) {
          lastProgress = 0.66;
          paintStory(0.66);
        }
        return;
      }

      /* Sticky pin; progress from section rect (window + .page-wrapper). */
      const rect = story.getBoundingClientRect();
      const total = Math.max(story.offsetHeight - window.innerHeight, 1);
      const progress = clamp(-rect.top / total, 0, 1);
      if (Math.abs(progress - lastProgress) < 0.001) return;
      lastProgress = progress;
      paintStory(progress);
    });
  };

  onStoryScroll();
  bindScroll(onStoryScroll);
  window.addEventListener('resize', onStoryScroll);
  innerScrollMq.addEventListener?.('change', onStoryScroll);
})();
